<div class="background"></div>

<div class="content">
  <div class="title">Genera la tua Locandina</div>
  <div class="subtitle">Scegli uno stile e scarica la tua locandina</div>

  <!-- Styles -->
  <div class="section">
    <h3>Scegli uno stile</h3>
    <div class="templates">
      <div
        class="template-card"
        [class.active]="selectedStyle === s.id"
        *ngFor="let s of styles"
        (click)="selectStyle(s.id)"
      >
        <img [src]="s.thumbnailUrl" [alt]="s.label" />
        <span class="template-label">{{ s.label }}</span>
      </div>
    </div>
  </div>

  <!-- Pastor info (Solo Domenica) -->
  <div class="section text-form" *ngIf="selectedStyle && nextEvent.dayString === 'sun'">
    <h3>Info Domenica</h3>
    <div class="form-group">
      <label for="pastorName">Pastore</label>
      <input
        id="pastorName"
        [(ngModel)]="pastorName"
        type="text"
        placeholder="Es. Gennaro Chiocca"
      />
    </div>
  </div>

  <!-- Text info -->
  <div class="section" *ngIf="selectedStyle">
    <p style="color: #666; font-size: 0.9rem;">
      <i>La data, l'ora e l'immagine di sfondo verranno impostate in automatico per il prossimo appuntamento (Martedì, Giovedì o Domenica).</i>
    </p>
  </div>

  <!-- Generate button -->
  <div class="section" *ngIf="selectedStyle">
    <button
      class="generate-button"
      [disabled]="isGenerating"
      (click)="generatePoster()"
    >
      <span *ngIf="!isGenerating">Genera Locandina</span>
      <span *ngIf="isGenerating">Generazione in corso...</span>
    </button>
  </div>

  <!-- Loading spinner -->
  <div class="loading" *ngIf="isGenerating">
    <div class="spinner"></div>
  </div>

  <!-- Poster preview + download -->
  <div class="section poster-preview" *ngIf="posterUrl">
    <img [src]="posterUrl" alt="Locandina generata" />
    <button class="download-button" (click)="sharePoster()">Condividi</button>
  </div>

  <!-- Error message -->
  <div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>
